import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=051e9b16&scoped=true"
import script from "./medical.vue?vue&type=script&lang=js"
export * from "./medical.vue?vue&type=script&lang=js"
import style0 from "./medical.vue?vue&type=style&index=0&id=051e9b16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e9b16",
  null
  
)

export default component.exports